import React from 'react'

import { 
	TextField, FormControl, InputLabel, Select, MenuItem,
	Card, CardContent, CardActions, Typography,
	Dialog, Button, FormControlLabel, Checkbox
} from '@material-ui/core'

const api = require('../../api/api')

export default class NewTopicEditor extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			open: false,
			data: null,
			loading: false,
			errors: {},

			name: '',
			lockedBy: 0,
			questionLocked: false,
			question: null,
			topicTypes: [],
			folder: 0,
			disabled: false
		}
	}

	componentDidMount() {
		this.fetchQuestionText()
	}

	fetchQuestionText() {
		api.questions.find({
			id: this.state.lockedBy
		}).then(data => {
			this.setState({
				question: data.question
			})
		}).catch(e => {
			console.error(e)

			this.setState({
				question: null
			})
		})
	}

	getData() {
		return {
			name: this.state.name,
			lockedBy: this.state.lockedBy,
			questionLocked: this.state.questionLocked,
			disabled: this.state.disabled,
			type: this.state.topicTypes[this.state.folder]
		}
	}

	handleTextChange(who, e) {
		let value = e.target.value

		if (who == 'name') {
			this.setState({
				name: value
			})
		} else if (who == 'folder') {
			this.setState({
				folder: value
			})
		} else if (who == 'lockedBy') {
			this.setState({
				lockedBy: value,
				question: null
			}, () => {
				if (value.length > 0) {
					this.fetchQuestionText()
				}
			})
		} else if (who == 'questionLocked') {
			value = e.target.checked

			this.setState({
				questionLocked: value
			})			
		} else if (who == 'disabled') {
			value = e.target.checked

			this.setState({
				disabled: value
			})			
		}
	}

	open(topicTypes) {
		this.setState({
			open: true,
			topicTypes: topicTypes,
			folder: 0
		})
	}

	close(self, added) {
		if (this.props.onClose) {
			this.props.onClose(added)
		}

		this.setState({
			open: false,

			name: '',
			lockedBy: 0,
			questionLocked: false,
			disabled: false
		})
	}

	showError(field, message) {
		let errors = this.state.errors
		errors[field] = message

		this.setState({
			errors: errors
		})
	}
	
	validate() {
		if (this.state.name.length == 0) {
			return this.showError('name', 'Please, input a topic name')
		}

		if (this.state.questionLocked && (!this.state.question || this.state.lockedBy < 0)) {
			return this.showError('lockedBy', 'Please, input a valid question lock ')
		}

		return true
	}

	create(e) {
		e?.preventDefault()

		if (this.validate()) {
			this.close(null, true)
		}
	}

	render() {
		return (
			<Dialog modal="true" open={this.state.open} onBackdropClick={this.close.bind(this)}>
				<form onSubmit={this.create.bind(this)}>
					<Card style={{ minWidth: 500, padding: 16 }}>
						<CardContent>
							<Typography gutterBottom>
								Create a new topic
							</Typography>
							<br/>
							
							{ this.renderForm() }
						</CardContent>
						<CardActions>
							<Button onClick={this.create.bind(this)} color="primary" variant="contained" type="submit">Create</Button>
							<Button onClick={this.close.bind(this)} variant="contained">Cancel</Button>
						</CardActions>
					</Card>
				</form>
			</Dialog>
		)
	}

	renderCheckbox() {
		if (this.state.questionLocked) {
			return 
		}
	}

	renderLock() {
		return <>
			<TextField type="number" fullWidth label={this.state.errors['lockedBy'] || 'Locked by'} error={this.state.errors['lockedBy'] && true || false} value={this.state.lockedBy} onChange={this.handleTextChange.bind(this, 'lockedBy')} /><br/><br/>
			{ this.state.question ? `Question #${this.state.lockedBy}: ${this.state.question.text}` : `Unknown question #${this.state.lockedBy}` }
		</>
	}

	renderForm() {
		return (
			<>
				<TextField autoFocus fullWidth label={this.state.errors['name'] || 'Name'} value={this.state.name} error={this.state.errors['name'] && true || false} onChange={this.handleTextChange.bind(this, 'name')} /> <br/><br/>
				<FormControl fullWidth>
					<InputLabel id="folder-label">Parent Topic</InputLabel>
					<Select
						labelId="folder-label"
						value={this.state.folder}
						id="folder-list"
						onChange={this.handleTextChange.bind(this, 'folder')}
					>
						{this.state.topicTypes.map((value, index) =>
							<MenuItem key={index} value={index}>{value}</MenuItem>
						)}
					</Select>
				</FormControl>
				<br/><br/>

				<FormControlLabel control={<Checkbox onChange={this.handleTextChange.bind(this, 'disabled')} value={this.state.disabled}  />} label='Disabled?' /> <br/><br/>
				<FormControlLabel control={<Checkbox onChange={this.handleTextChange.bind(this, 'questionLocked')} value={this.state.questionLocked}  />} label='Question Locked?' /> <br/><br/>

				{ this.state.questionLocked && this.renderLock() }
			</>
		)
	}
}
